// import $ from "jquery";
// import "slick-carousel";
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

class casestudyCard {
  constructor() {
    if ($(window).width() < 768) {
      this.sliderInit();
      this.paginationClass = $('.slider-01-control .slider__pagination');
      this.events();
    }
    this.collapseInit();
  }

  collapseInit() {
    if (document.querySelector('.page-id-27592 .case-study button') != 'null')
      $('.page-id-27592 .case-study button').removeClass('d-none');
    if (document.querySelector('.page-id-30245 .case-study button') != 'null')
      $('.page-id-30245 .case-study button').removeClass('d-none');
    if (document.querySelector('.page-id-29998 .case-study button') != 'null')
      $('.page-id-29998 .case-study button').removeClass('d-none');

    $('.longCollapse').click(function () {
      var collapseID = $(this).attr('data-target');
      if ($('.' + collapseID).hasClass('show')) {
        $(this).html('Read more');
        $('.' + collapseID)
          .removeClass('show')
          .animate(5000);
      } else {
        $(this).html('Read less');
        $('.' + collapseID)
          .addClass('show')
          .animate(5000);
      }
    });
  }

  sliderInit() {
    Swiper.use([Navigation, Pagination, Autoplay]);
    var swiper = new Swiper('.slider', {
      slidesPerView: 1,
      spaceBetween: 36,
      grabCursor: true,
      loop: false,
      speed: 500,
      allowTouchMove: false,
      pagination: {
        el: '.slider-01-control .slider__pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.slider-01-control .slider__button-next',
        prevEl: '.slider-01-control .slider__button-prev',
      },
      breakpoints: {
        767: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
      },
    });
  }

  resizeEvents() {
    $(window).on('resize', () => {
      this.sliderInit();
    });
  }

  clickEvents() {}

  events() {
    this.clickEvents();
    this.resizeEvents();
  }
}

export default casestudyCard;
new casestudyCard();
